var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlutter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.4535,
    cy: 22.4535,
    r: 22.4535,
    fill: "#F5F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1211 11L13.1083 22L16.4999 25.3917L30.8769 11.011H24.133L24.1211 11ZM24.1339 21.1493L18.2022 27.0683L22.5 31L24.5 33L30.8916 32.9991L24.9699 27.0701L30.8916 21.1484H24.1349L24.1339 21.1493Z",
    fill: "#2176FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 31L24.2032 33H33L25.9632 27",
    fill: "#2176FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9865 23.336L17.8298 27.1473L22.184 31.1375L26.3407 27.3261L21.9865 23.336Z",
    fill: "#FFCA00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/flutter.23513b6beda496beab5b8edc11367e3b.svg";
export { ForwardRef as ReactComponent };